import { Box, FormLabel } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { useTranslation } from "react-i18next";

import "./OutboundScheduleForm.scss";

interface OutboundScheduleFormProps {
  goodsIssuePlanned: Date | null;
  setGoodsIssuePlanned: (date: Date | null) => void;
  deliveryDatePlanned: Date | null;
  setDeliveryDatePlanned: (date: Date | null) => void;
}

const OutboundScheduleForm = (props: OutboundScheduleFormProps) => {
  const { t } = useTranslation();
  const {
    goodsIssuePlanned,
    setGoodsIssuePlanned,
    deliveryDatePlanned,
    setDeliveryDatePlanned,
  } = props;

  return (
    <Box
      className="form-flex-container"
      component="form"
      sx={{ width: "100%" }}
      autoComplete="off"
    >
      <div>
        <FormLabel required>{t("goodsIssuePlanned")}</FormLabel>
        <DateTimePicker
          className="input-element"
          ampm={false}
          value={goodsIssuePlanned}
          onChange={setGoodsIssuePlanned}
          onAccept={setGoodsIssuePlanned}
          disablePast
        />
      </div>
      <div>
        <FormLabel>{t("deliveryDatePlanned")}</FormLabel>
        <DateTimePicker
          className="input-element"
          ampm={false}
          value={deliveryDatePlanned}
          onChange={setDeliveryDatePlanned}
          onAccept={setDeliveryDatePlanned}
          disablePast
        />
      </div>
    </Box>
  );
};
export default OutboundScheduleForm;
